const { padStart } = require('lodash');

module.exports = function () {
    return function (cardNumber = '') {
        return padStart(cardNumber.slice(-4), 19, 'XXXX XXXX XXXX XXXX');
    };
};



// WEBPACK FOOTER //
// ./src/common/filters/wow-mask-card-number.filter.js